import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAutoSunMoonLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='m18.794 9.752-.358-1.002h-2.872l-.358 1.002a.75.75 0 0 1-1.412-.504l2.029-5.682c.395-1.106 1.96-1.106 2.354 0l2.03 5.682a.75.75 0 0 1-1.413.504M16.1 7.25l.9-2.52.9 2.52z'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M11.642 7.441a1 1 0 0 0-1.229-1.229 6 6 0 1 0 7.375 7.375 1 1 0 0 0-1.229-1.228 4.006 4.006 0 0 1-4.917-4.918M8 12.001c0-1.268.59-2.4 1.511-3.133a6 6 0 0 0 5.62 5.621A4 4 0 0 1 8 12'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      d='M12 19.5a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1M5.99 19.425l.707-.707a1 1 0 1 0-1.415-1.415l-.707.707a1 1 0 1 0 1.414 1.415M4.5 12a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1M17.303 18.718l.707.707a1 1 0 1 0 1.415-1.415l-.707-.707a1 1 0 0 0-1.415 1.415M5.283 6.697a1 1 0 0 0 1.414-1.415l-.707-.707A1 1 0 1 0 4.575 5.99z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAutoSunMoonLine)
export default ForwardRef
